export enum SortColumn {
    Title = 'title',
    Updated = 'updated',
    ClassificationMarking = 'classifcationMarking',
    DocumentType = 'documentType',
    IsPublished = 'isPublished',
    Relevance = 'relevance'
}